import { render, staticRenderFns } from "./CadastroConfiguracaoFrete.vue?vue&type=template&id=43d4335c"
import script from "./CadastroConfiguracaoFrete.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports